import winning_analyser from "libs/winning-analyser.js";
import 'whatwg-fetch';

var blockUIMessage = false;
var kickOutUIMessage = false;
var notSyncMessage = false;

let delay = 500;

// Effet sur le click sur une case valide
const validCaseClickBurst = new mojs.Burst({
	left: 0, top: 0,
	radius: { 0: 30 },
	angle: 'rand(0, 360)',
	children: {
		shape: 'line',
		stroke: '#071e4e',
		fill: 'none',
		scale: 1,
		scaleX: { 1: 0 },
		easing: 'cubic.out',
		duration: 1000
	}
});

const validCaseClickBubbles = new mojs.Burst({
	left: 0, top: 0,
	radius: 60,
	count: 3,
	timeline: { delay: 100 },
	children: {
		stroke: '#7CFC00',
		fill: 'none',
		scale: 1,
		strokeWidth: { 8: 0 },
		radius: { 0 : 'rand(6, 10)' },
		degreeShift: 'rand(-50, 50)',
		duration: 400,
		delay: 'rand(0, 250)',
	}
});


// Feux d'artifices pour un bingo
const fireworks_burst1 = new mojs.Burst({
	left: 0, top: 0,
	count: 8,
	radius: { 50: 150 },
	children: {
		shape: 'line',
		stroke: [ 'white', '#FFE217', '#FC46AD', '#D0D202', '#B8E986', '#D0D202' ],
		scale: 1,
		scaleX: { 1 : 0 },
		degreeShift: 'rand(-90, 90)',
		radius: 'rand(20, 40)',
		delay: 'rand(0, 150)',
		isForce3d: true
	}
});

const fireworks_largeBurst = new mojs.Burst({
	left: 0, top: 0,
	count: 4,
	radius: 0,
	angle: 45,
	radius: { 0: 450  },
	children: {
		shape: 'line',
		stroke: '#4ACAD9',
		scale: 1,
		scaleX: { 1 : 0 },
		radius: 100,
		duration: 450,
		isForce3d: true,
		easing: 'cubic.inout'
	}
});

const fireworks_largeCircle = new mojs.Shape({
	left: 0, top: 0,
	scale: { 0: 1 },
	fill: 'none',
	stroke: 'white',
	strokeWidth: 4,
	opacity: { .25 : 0 },
	radius: 250,
	duration: 600,
});

const fireworks_smallCircle = new mojs.Shape({
	left: 0, top: 0,
	scale: { 0: 1 },
	fill: 'white',
	opacity: { .5 : 0 },
	radius: 30,
});

function launchFirework( positionX, positionY, delay ) {
	fireworks_burst1.el.style.zIndex = 9999;
	fireworks_largeBurst.el.style.zIndex = 9999;
	fireworks_largeCircle.el.style.zIndex = 9999;
	fireworks_smallCircle.el.style.zIndex = 9999;

	if( delay !== undefined && delay > 0 ) {
		setTimeout( function() {
			fireworks_burst1.tune({ x: positionX, y: positionY, isShowEnd: false }).generate().replay();
			fireworks_largeBurst.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
			fireworks_largeCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
			fireworks_smallCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		}, delay );
	} else {
		fireworks_burst1.tune({ x: positionX, y: positionY, isShowEnd: false }).generate().replay();
		fireworks_largeBurst.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		fireworks_largeCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
		fireworks_smallCircle.tune({ x: positionX, y: positionY, isShowEnd: false }).replay();
	}
}

function winnerFirework() {
	let windowWidth = window.innerWidth - 100,
		windowHeight = window.innerHeight - 100,
		randomX, randomY;

	randomX = Math.floor( Math.random() * windowWidth ) + 100;
	randomY = Math.floor( Math.random() * windowHeight ) + 100;

	launchFirework( randomX, randomY, 250 );

	randomX = Math.floor( Math.random() * windowWidth ) + 100;
	randomY = Math.floor( Math.random() * windowHeight ) + 100;

	launchFirework( randomX, randomY, 700 );

	randomX = Math.floor( Math.random() * windowWidth ) + 100;
	randomY = Math.floor( Math.random() * windowHeight ) + 100;

	launchFirework( randomX, randomY, 1200 );

	randomX = Math.floor( Math.random() * windowWidth ) + 100;
	randomY = Math.floor( Math.random() * windowHeight ) + 100;

	launchFirework( randomX, randomY, 1650 );

	randomX = Math.floor( Math.random() * windowWidth ) + 100;
	randomY = Math.floor( Math.random() * windowHeight ) + 100;
	
	launchFirework( randomX, randomY, 2175 );
}

function checkIfCardIsInRange( numCard, range ) {
	var isInRange = false;

	numCard = parseInt( numCard );

	if( range === null ) { return true; }

	// On enlève les espaces, ensuite on va splitter avec les ,
	rangeArr = range.replace(/\s/g, '').split( ',' );

	// console.log( rangeArr );

	rangeArr.forEach( function( item ) {
		var sub_range;

		// Si on est dans un range
		if( item.indexOf( '-' ) > -1 ) {
			subRangeArr = item.split( '-' ).sort();

			if( numCard >= parseInt( subRangeArr[0] ) && numCard <= parseInt( subRangeArr[1] ) ) {
				isInRange = true;return;
			}
		} else if( parseInt( item ) === numCard ) {
			isInRange = true;return;
		}

	} );

	return isInRange;
}


export function clear_storage( keep_gameIteration, popup_winning_ways ) {
	sessionStorage.removeItem('pick');
	sessionStorage.removeItem('nbWin');
	sessionStorage.removeItem('localNbWin');

	localStorage.removeItem('checkStateInProgress');
	localStorage.removeItem('activation');

	if( popup_winning_ways === true ) {
		localStorage.removeItem('active_winning_ways_showed');
	}

	if( keep_gameIteration !== true ) {
		localStorage.removeItem('gameIteration');
	}
}

export function showLoading( disable, callback ) {
	if( disable == undefined || disable == true ) {
		$('#loading').show().css('z-index', 99);
	} else {
		$('#loading').hide().css('z-index', -1);
	}

	if( typeof callback == "function" ) {
		callback();
	}
}

export function passwordForNewCard() {
	window.addCardModal = UIkit.modal.blockUI( $('#passwordForNewCard').html(), { center: true } );
}


if( ! String.prototype.format ) {
	String.prototype.format = function () {
		let args = arguments;
		return this.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != 'undefined' ? args[number] : match ;
		});
	};
}

export function clickBingoBox( bingoBox, event ){

	if( bingoBox.hasClass('click') ) {

		let formData = new FormData();

		formData.append( 'box_id', parseInt( bingoBox.data("id-box") ) );
		formData.append( 'box_value', parseInt( bingoBox.data("box-value") ) );
		formData.append( 'caller_id', parseInt( callerGlobals.caller.id ) );
		formData.append( 'project_type', parseInt( callerGlobals.project.type ) );
		formData.append( 'csrf_tk_bingomaker', csrf_token );

		let idCard = bingoBox.closest( '.card' ).data('card-id');

		fetch( callerGlobals.general.rootURL + "webcardsapi/mark_as_clicked", {
			method: 'POST',
			body: formData
		}).then(function(response){
			if( response.ok ) {
				return response.json();
			} else {
				console.log("erreur");
			}
		}).then(function(data){

			if( data.result == 'success' ) {
				let wins = {};

				bingoBox.addClass("clicked");

				let posX = event.pageX || event.changedTouches[0].pageX;
				let posY = event.pageY || event.changedTouches[0].pageY;

				// Début : Petite animation funky
				validCaseClickBurst
					.tune({ x: posX, y: posY })
					.generate()
					.replay();
			
				validCaseClickBubbles
					.tune({ x: posX, y: posY })
					.generate()
					.replay();
				// Fin : Petite animation funky

				let winningAnalyser = new winning_analyser({
					card: $('#card_' + idCard),
					mark_bingo: true,
					remove_empty: true,
					winning: callerGlobals.game.waysToWin,
				});

				wins[ idCard ] = winningAnalyser.init();

				if( Object.keys( wins ).length > 0 ) {
					validate_wins( wins );
				}
			} else {
				bingoBox.removeClass("click");
				bingoBox.addClass("noaction");

				bingoBox.toggleClass('no-case');

				setTimeout(function(){
					bingoBox.toggleClass('no-case', false);
				}, 250);
			}

		})
		.catch(function(error){
			console.log(error);
		});
	}
}

export function clickBingoBoxes( bingoBoxes ) {
	let formData = new FormData();

	formData.append( 'caller_id', parseInt( callerGlobals.caller.id ) );
	formData.append( 'project_type', parseInt( callerGlobals.project.type ) );
	formData.append( 'csrf_tk_bingomaker', csrf_token );

	bingoBoxes.each( function( index ) {

		formData.append( 'box_id[]', parseInt( $(this).data("id-box") ) );
		formData.append( 'box_value[]', parseInt( $(this).data("box-value") ) );

	} );

	fetch( callerGlobals.general.rootURL + "webcardsapi/mark_as_clicked", {
		method: 'POST',
		body: formData
	}).then( function( response ) {

		if( response.ok ) {
			return response.json();
		} else {
			console.log("erreur");
		}

	}).then( function( data ) {

		if( data.result == 'success' ) {

			let boxesToClick = data.data,
				cards = $('.cards');

			$.each( boxesToClick, function( index, boxId ) {

				let thisBox = cards.find('.case[data-id-box=' + boxId + ']'),
					thisCard = thisBox.closest( '.card' ),
					relatedTabBtn = $( '#tab_btn_' + thisCard.data('card-id') );

				thisBox.addClass("clicked").addClass('new');

				if( ! relatedTabBtn.hasClass('active') ) {
					if( ! relatedTabBtn.hasClass( 'highlight' ) ) {
						relatedTabBtn.addClass( 'highlight' );
					} else {
						relatedTabBtn.removeClass( 'highlight' );
						setTimeout( function( ) {
							relatedTabBtn.addClass( 'highlight' );
						}, 50 );
					}
				} else {//Après 3 secondes on va arrêter les nouvelles case de flasher
					setTimeout( function() {
						thisCard.find('.new').each( function() {
							$(this).removeClass( 'new' );
						} );
					}, 3000 );
				}

			} );

			// On va vérifier les victoires dans toutes les cartes
			let wins = {};

			cards.find('.card').each( function() {
				let winningAnalyser = new winning_analyser({
					card: $(this),
					mark_bingo: true,
					remove_empty: true,
					winning: callerGlobals.game.waysToWin,
				});

				let thisCardWins = winningAnalyser.init();

				if( Object.keys( thisCardWins ).length > 0 ) {
					wins[ $(this).data('card-id') ] = thisCardWins;
				}
			} );

			if( Object.keys( wins ).length > 0 ) {
				validate_wins( wins );
			}

		} else {
			console.log( data.message )
		}

	}).catch( function( error ) {
		console.log( error );
	});
}

function validate_wins( wins ) {
	// Vérifier qu'il y a de nouvelles victoire avant de faire une requête.
	let dynamic_nb_wins = 0,
		wins_keys = Object.keys( wins );

	for( let i = 0; i < wins_keys.length; i++ ) {

		let cards_wins_keys = Object.keys( wins[ wins_keys[i] ] );

		for( let j = 0; j < cards_wins_keys.length; j++ ) {

			dynamic_nb_wins += wins[ wins_keys[ i ] ][ cards_wins_keys[ j ] ].length;

		}

	}

	if( dynamic_nb_wins !== callerGlobals.game.totalWins ) {
		let formData = new FormData();

		formData.append('wins', JSON.stringify( wins ) );
		// formData.append('card_id', idCard );
		formData.append('caller_id', callerGlobals.caller.id );
		formData.append('player_id', callerGlobals.player.id );
		formData.append('free_center', callerGlobals.project.freeCenter );
		formData.append('csrf_tk_bingomaker', csrf_token);

		fetch( callerGlobals.general.rootURL + "webcardsapi/validate_wins", {
			method: 'POST',
			body: formData
		}).then(function( response ) {
			if( response.ok ) {
				return response.json();
			} else {
				console.log("erreur");
			}
		}).then(function( data ) {
			if( data.result == 'success' ) {
				let base_message = callerGlobals.i18n.bingoAlert,
					bingos_message = '';

				$('.nbWins').text( data.nb_wins );
				callerGlobals.game.totalWins =  data.nb_wins;

				$.each( data.validated_wins, function( idCard, card_wins ) {

					// On va vérifier si cette carte à de nouvelles combinaison gagnante
					if( parseInt( callerGlobals.game.nbWins[idCard] ) < parseInt( card_wins.nb_wins ) ) {

						callerGlobals.game.nbWins[idCard] = card_wins.nb_wins;

						$.each( card_wins.validated_wins, function( wins_index, bingo_type ) {

							if( typeof bingo_type === 'object' ) {

								$.each( bingo_type, function( sub_bingo_type, validation_result ) {
									if( validation_result && $.inArray( sub_bingo_type, callerGlobals.game.winsDisplayed[idCard] ) < 0 ) {
										callerGlobals.game.winsDisplayed[idCard].push( sub_bingo_type );

										bingos_message += '<div class="winning-way ' + sub_bingo_type + '"><div class="winning-way-inner">' +
														'<svg class="winning-way-svg ' + card_wins.winning_img_classes[sub_bingo_type] + '">' +
															'<use xlink:href="#cardSVG" />' +
														'</svg>' +
														'<div class="label">' +
															callerGlobals.i18n.cardTxt + ' #' + card_wins.noCard + '<br>' +
															'<em>' + callerGlobals.i18n.winning_lang[ sub_bingo_type ] + '</em>' +
														'</div>' +
													'</div></div>';
									}
								});

							} else {

								if( bingo_type && $.inArray( wins_index, callerGlobals.game.winsDisplayed[idCard] ) < 0 ) {
									callerGlobals.game.winsDisplayed[idCard].push( wins_index );

									bingos_message += '<div class="winning-way ' + wins_index + '"><div class="winning-way-inner">' +
														'<svg class="winning-way-svg ' + card_wins.winning_img_classes[wins_index] + '">' +
															'<use xlink:href="#cardSVG" />' +
														'</svg>' +
														'<div class="label">' +
															callerGlobals.i18n.cardTxt + ' #' + card_wins.noCard + '<br>' +
															'<em>' + callerGlobals.i18n.winning_lang[ wins_index ] + '</em>' +
														'</div>' +
													'</div></div>';
								}

							}
						});

						let relatedTabBtn = $( '#tab_btn_' + idCard );

						if( ! relatedTabBtn.hasClass('active') && ! relatedTabBtn.hasClass( 'wins' ) ) {
							relatedTabBtn.removeClass( 'highlight' );
							relatedTabBtn.addClass( 'wins' );
						}

					}
				});

				if( bingos_message ) {
					base_message = base_message.format( bingos_message );
					winnerFirework();// On lance la pyrotechnie

					UIkit.modal.alert( base_message, {
						center: true,
						labels: {
							Ok: callerGlobals.i18n.bingoAlertBtn,
						}
					} )/*.on('hide.uk.modal', function() {
						winnerFirework();// On lance la pyrotechnie
					});*/

				}
			} else {// On a un petit comique qui a essayé de bypasser le système, donc on lui dit que sa carte n'est plus synchro et on reload
				$('.uk-modal').remove();
				// clearInterval(checkUserPhoneLock);

				notSyncMessage = UIkit.modal.alert(callerGlobals.i18n.not_sync, {
					center: true, labels:{
						Ok: callerGlobals.i18n.gameTheGame,
					}
				}).on('hide.uk.modal', function() {
					showLoading();
					location.reload();
				});
			}
		})
		.catch(function(error){
			console.log(error);
		});
	}
}

export function stateGame( cpt ){
	window.pauseInterval = true;

	if( localStorage.getItem("checkStateInProgress") !== null ) {
		return;
	} else {
		localStorage.setItem("checkStateInProgress", 1);
	}

	let url = callerGlobals.general.rootURL + "webcardsapi/getGameState",
		formData = new FormData(),
		pauseRestartMsg = false,
		currentActiveDraw = $('#draws .current-draw .draw-value').data('numeric-value');

	formData.append( 'idCaller', callerGlobals.caller.id );
	formData.append( 'idPlayer', callerGlobals.player.id );
	formData.append( 'projectStart', callerGlobals.project.start );
	formData.append( 'projectType', callerGlobals.project.type );
	formData.append( 'projectIsFree', callerGlobals.game.isFree );
	formData.append( 'csrf_tk_bingomaker', csrf_token );

	fetch( callerGlobals.general.rootURL + "webcardsapi/getGameState/", {
		method: 'POST',
		body: formData
	} )
	.then( function( response ) {
		if( response.ok ) {
			return response.json();
		} else {
			console.log("erreur");
		}
	})
	.then( function( response ) {

		let result = response.result,
			data = response.data;

		if( localStorage.getItem( 'gameIteration' ) === null && data.iteration == 1 ) {
			localStorage.setItem( 'gameIteration', data.iteration );
		}

		switch( result ) {
			case 'ended':
				callerGlobals.general.canClick = false;
				sessionStorage.setItem( 'pick', false );
				delete_cookie("activeCard");
				delete_cookie("idCaller");

				exitCurrentGame();
			break;

			case 'error':
				callerGlobals.general.canClick = false;

				exitCurrentGame();
			break;

			case 'success':
			default:

				if( data.csrf_token !== undefined && data.csrf_token !== null && data.csrf_token !== '' ) {
					csrf_token = data.csrf_token;
				}

				// On va vérifier si l'itération de la partie à changé
				if( localStorage.getItem( 'gameIteration' ) !== data.iteration ) {

					localStorage.setItem( "gameIteration", data.iteration );
					onRestart();

				} else {

					// S'il y a des cartes kickout, on vérifie si l'une du joueur est concerné
					if( data.toBan != false ) {
						if( ! notSyncMessage && ! kickOutUIMessage ) {
							pauseRestartMsg = true;
							stillHasCardToBan = false;

							$.each( data.toBan, function( key, card ) {
								if( callerGlobals.cards.nums.indexOf( parseInt( card ) ) >= 0 ) {
									stillHasCardToBan = true;
								}
							});

							if( stillHasCardToBan ) {
								kickOutUIMessage = UIkit.modal.alert( callerGlobals.i18n.bannedCardsMsg, {
									center: true
								} ).on('hide.uk.modal', function() {
									// Le user n'a plus de carte du tout, on va faire le ménage dans sa session et ses cookies
									if( callerGlobals.cards.nums.length - data.toBan.length < 1 ) {
										localStorage.removeItem( "gameIteration" );
										localStorage.removeItem( "active_winning_ways_showed" );

										delete_cookie( "activeCard" );
										delete_cookie( "idCaller" );
										delete_cookie( "web_card_" + callerGlobals.caller.id );

										clearInterval( window.gameTimer );
										clear_storage();

										window.location.href = callerGlobals.general.gamesListingURL;
									} else {// Le user a encore des cartes, on va supprimer celle en question et on refresh la page pour que ça continu de fonctionner.
										$.each( data.toBan, function( key, card ) {
											$('.card[data-card-num="' + card + '"]').remove();
											$('.tab-btn[data-card-num="' + card + '"]').parent().remove();

											callerGlobals.cards.nums.splice( key, 1 );
										} );

										window.location.reload();
									}
								});
							}

						}

					}

					// Si un message est actif, on vérifie s'il concerne l'une des cartes du joueur
					if( data.blockUIMessage !== null && data.blockUIMessage !== undefined ) {

						// Si le message n'est pas déjà activé
						if( ! blockUIMessage ) {
							// Regarder si on fait partie des cartes concernées par le message
							let ifIsInRange = false;

							$.each( callerGlobals.cards.nums, function( key, numCard ) {
								if( checkIfCardIsInRange( numCard, data.blockUIMessage.cards ) ) {
									ifIsInRange = true;
									return false;
								}
							} );

							if( ifIsInRange ) {

								if( ( ! notSyncMessage || ( notSyncMessage && ! notSyncMessage.isActive() ) ) && ( ! blockUIMessage || ( blockUIMessage && ! blockUIMessage.isActive() ) ) ) {
									blockUIMessage = UIkit.modal.blockUI( '<h2>' + callerGlobals.i18n.titleMsgBlockUi + "</h2>\n" + data.blockUIMessage.message, {
										center: true
									});
								}

							}/* else {// Todo, traduire ce message
								blockUIMessage = UIkit.modal.blockUI( "<h2>Partie en pause</h2>\n<p>L'organisateur communique avec un joueur, la partie recommencera toute seule lorsqu'il aura terminé.</p>", {
										center: true
									});
							}*/
						}

					// S'il y a des gagnants, la partie est fini, on va afficher le modal de victoire et attendre que l'organisateur redémarre ou ferme le caller
					} else if( data.drawResult.message !== undefined && window.winner_popup_is_open == false ) {

						window.winner_popup_is_open = true;

						if( callerGlobals.game.isFree == 0 ) {
							UIkit.modal.blockUI( data.drawResult.message, { center: true } );
						} else {
							UIkit.modal.alert( data.drawResult.message, {
								center: true,
								labels: { 'Ok': 'Ok' }
							}).on({
								'hide.uk.modal': function() {
									showLoading();
									clearInterval( window.gameTimer);

									sessionStorage.clear();
									localStorage.clear();

									window.location.href = callerGlobals.general.gamesListingURL;
								}
							});
						}

						// Si c'est un gagnant, on lance la pyrotechnie
						if( data.drawResult.isWinner ) {
							winnerFirework();
						}


					} else {

						// S'il y avait un message afficher, on le masque
						if( blockUIMessage && blockUIMessage.isActive() ) { blockUIMessage.hide(); blockUIMessage = false; }

						if( data.currentCase != false ) {

							let currentCase = data.currentCase,

								numberClass = callerGlobals.project.type == 1 ? 'number' : '',

								drawsList = $("#draws_list"),
								nbWinsEl = $('#nbWins'),

								drawsWrapper = $('#draws'),

								drawCurrent = drawsWrapper.find( '.current-draw .draw-inner' ),

								previousDraw1 = drawsWrapper.find( '#previous_draw_1 .draw-inner' ),
								previousDraw2 = drawsWrapper.find( '#previous_draw_2 .draw-inner' ),
								previousDraw3 = drawsWrapper.find( '#previous_draw_3 .draw-inner' ),
								previousDraw4 = drawsWrapper.find( '#previous_draw_4 .draw-inner' ),
								previousDraw5 = drawsWrapper.find( '#previous_draw_5 .draw-inner' );

							if( parseInt( currentActiveDraw ) !== parseInt( currentCase.value ) ) {
								callerGlobals.game.playedValues.push( currentCase );

								currentActiveDraw = currentCase.value;

								let nbCall  = $("#nbCall");

								nbCall.text( callerGlobals.game.playedValues.length );

								let newSong = $(
									'<div class="draw-letter-wrapper">' + "\n" +
										'<div class="draw-letter">' + currentCase.letterToShow + '</div>' + "\n" +
									'</div>' + "\n" +

									'<div class="draw-value" data-numeric-value="' + currentCase.value + '">' + ( currentCase.html === undefined ? currentCase.title : currentCase.html.full ) + '</div>' + "\n"// +
								);

								nbWinsEl.text();

								drawsList.prepend( $(
									'<div id="draw' + currentCase.value + '" class="row">' + "\n" +
									'	<div class="draw-letter">' + currentCase.letterToShow + '</div>' + "\n" +
									'	<div class="separator"> - </div>' + "\n" +
									'	<div class="draw-value">' + ( currentCase.html === undefined ? currentCase.title : currentCase.html.full ) + '</div>' + "\n" +
									'</div>' + "\n"
								) );

								// On va mettre à jour les ancien tirages en commençant par le dernier
								if( drawCurrent.find( '.draw-value' ).length > 0 ) { fadeChange( previousDraw1, drawCurrent.html() ); }
								if( previousDraw1.find( '.draw-value' ).length > 0 ) { fadeChange( previousDraw2, previousDraw1.html() ); }
								if( previousDraw2.find( '.draw-value' ).length > 0 ) { fadeChange( previousDraw3, previousDraw2.html() ); }
								if( previousDraw3.find( '.draw-value' ).length > 0 ) { fadeChange( previousDraw4, previousDraw3.html() ); }
								if( previousDraw4.find( '.draw-value' ).length > 0 ) { fadeChange( previousDraw5, previousDraw4.html() ); }

								fadeChange( drawCurrent, newSong );

								// Jouer l'audio du tirage
								if( window.audioEnabled === 1 ) {
									let lowerLetter = currentCase.letter.toLowerCase();

									if( callerGlobals.project.type == 1 ) {
										let audioBaseUrl = callerGlobals.general.rootURL + 'audio/draw/' + site_lang.substr( 0, 2 ) + '/';

										let audio_file = audioBaseUrl + lowerLetter + '/' + lowerLetter + currentCase.value + '.mp3';
										window.callerVoice.src = audio_file;
										window.callerVoice.play();
									} else {
										let audioLetterUrl = callerGlobals.general.rootURL + 'audio/letter/' + site_lang.substr( 0, 2 ) + '/',
											audioEmojiUrl = callerGlobals.general.rootURL + 'audio/emoji/' + site_lang.substr( 0, 2 ) + '/',
											emojiHasPlayed = false;

										// On est dans un projet emoji, on va lire la lettre et ensuite le nom de l'emoji
										window.callerVoice.src = audioLetterUrl + lowerLetter + '.mp3';
										window.callerVoice.play();

										window.callerVoice.onended = function() {
											if( ! emojiHasPlayed ) {
												window.callerVoice.src = audioEmojiUrl + data.currentCase.title + '.mp3';
												window.callerVoice.play();

												emojiHasPlayed = true;
											}
										};
									}
								}
							}

							$('.case-' + currentCase.value).removeClass('noaction').addClass("click");

							callerGlobals.general.canClick = true;
							sessionStorage.setItem('pick', true);

						}

					}

				}


			break;

		}

		window.pauseInterval = false;

		if( ! pauseRestartMsg ) {
			if( cpt > 0 && cpt % 5 === 0 ) {
				updPickList();
			}
		}

		localStorage.removeItem("checkStateInProgress");

	}).catch(function(error){
		console.log(error);
	});
}

export function onRestart() {
	callerGlobals.general.canClick = false;
	sessionStorage.setItem('pick', false);
	clearInterval( window.gameTimer );

	$('.uk-modal').remove();

	UIkit.modal.alert(callerGlobals.i18n.gameRestartAlert, {
		center: true,
		labels: {
			Cancel: callerGlobals.i18n.exitGame,
			Ok: callerGlobals.i18n.gameTheGame,
		}
	}).on('hide.uk.modal', function() {
		showLoading();

		clear_storage( true, true );

		window.location.reload();
	});
}

export function delete_cookie( name ) {
	document.cookie = callerGlobals.cookie.prefix + name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function fadeChange( container, content ){
	container.fadeOut( delay, function(){
		container.html( content );
		container.fadeIn();
	});
}
export function exitCurrentGame() {
	clearInterval( window.gameTimer );
	clear_storage();

	setTimeout(function(){
		window.location.href = callerGlobals.general.rootURL + "cardInteractive/exitGame/" + callerGlobals.caller.id + '/';
	}, 30000);

	UIkit.modal.alert(
		callerGlobals.i18n.endGameAlert, {
			center: true,
			labels:{
				Ok: callerGlobals.i18n.exitGame
		}
	}).on('hide.uk.modal', function() {
		showLoading();
		window.location.href = callerGlobals.general.rootURL + "cardInteractive/exitGame/" + callerGlobals.caller.id + '/';
	});
}

export function updPickList() {
	window.pauseInterval == true;

	let url =  callerGlobals.general.rootURL + "webcardsapi/getUpdPickList/?";
	let box;

	let param = {
		"id": callerGlobals.caller.id,
		"emojiCard": callerGlobals.project.isEmoji,
		'csrf_tk_bingomaker': csrf_token
	};

	fetch( url + $.param( param ) )
	.then(function(response){
		if( response.ok ){
			return response.json();
		} else {
			console.log("erreur");
		}
	})
	.then(function(data){
		var listConstructor = "";
		var cptPick = 0;

		if( $('#draws_list').children() && data.message.allCase && $('#draws_list').children().length !== data.message.allCase.length ) {
			$.each( data.message.allCase, function( key, value ) {
				box = $('.case-' + value.value);

				box.removeClass('noaction');
				if( ! box.hasClass('click') ) {
					box.addClass('click');
				}

				listConstructor +=
					'<div id="draw' + value.value + '" class="row">' +
						'<div class="draw-letter">' + ( value.letterToShow ? value.letterToShow : value.letter ) + '</div>' +
						'<div class="separator"> - </div>' +
						'<div class="draw-value">' + ( value.html === undefined ? value.title : value.html ) + '</div>' +
					'</div>';

				cptPick ++;
			});

			$('#nbCall').html( cptPick );

			$('#draws_list').html( listConstructor );
		}

		window.pauseInterval = false;

	}).catch(function(error){
		console.log(error);
	});
}

export function getTime() {
	return (new Date()).getTime();
}

export function show_active_winning_ways() {
	var winningWaysModal = UIkit.modal.blockUI( $('#active_winning_ways').html(), { center: true } );

	setTimeout(function(){
		if( winningWaysModal != 'undefined' ) {
			winningWaysModal.hide();
		}
	}, 20000);
}
